(() => {
  const panel = document.getElementById('sg-favorites-dialog');
  if (!panel || customElements.get('sg-favorite')) return;
  const key = 'secret-gainant.favorites.v1';
  const labels = panel.dataset;
  const status = document.getElementById('sg-favorites-status');
  const list = panel.querySelector('[data-sg-list]');
  let items = [];
  let opener;
  let previousOverflow;
  const safeItem = (item) => {
    if (!item || typeof item.handle !== 'string' || !/^[a-z0-9-]+$/.test(item.handle)) return false;
    try {
      const url = new URL(item.url, location.origin);
      return url.origin === location.origin && url.pathname.includes('/products/') && typeof item.title === 'string';
    } catch { return false; }
  };
  const read = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(saved) ? saved.filter(safeItem).filter((v,i,a) => a.findIndex(x => x.handle === v.handle) === i) : [];
    } catch { items = []; }
  };
  const announce = (message) => { status.textContent = ''; requestAnimationFrame(() => { status.textContent = message; }); };
  const refresh = () => {
    document.querySelectorAll('sg-favorite').forEach(el => el.sync?.());
    document.querySelectorAll('[data-sg-count]').forEach(el => {
      el.textContent = String(items.length);
      el.hidden = el.classList.contains('sg-favorites-badge') && !items.length;
    });
    document.querySelectorAll('[data-sg-open]').forEach(el => { el.hidden = false; });
  };
  const save = (next, message) => {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(labels.error); return false; }
    items = next;
    refresh();
    if (panel.open) render();
    announce(message);
    return true;
  };
  class Favorite extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      if (!this.bound) {
        this.bound = true;
        this.button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const item = { handle: this.dataset.handle, title: this.dataset.title, url: this.dataset.url, image: this.dataset.image };
          if (!safeItem(item)) return;
          const exists = items.some(p => p.handle === item.handle);
          save(exists ? items.filter(p => p.handle !== item.handle) : [...items, item], exists ? labels.removed : labels.saved);
        });
      }
      this.button.hidden = false;
      this.sync();
    }
    sync() {
      if (!this.button) return;
      const active = items.some(p => p.handle === this.dataset.handle);
      this.button.setAttribute('aria-pressed', String(active));
      const label = active ? labels.remove : labels.add;
      this.button.setAttribute('aria-label', `${label} — ${this.dataset.title}`);
      const text = this.querySelector('[data-sg-label]');
      if (text) text.textContent = label;
    }
  }
  const render = () => {
    list.replaceChildren();
    panel.querySelector('[data-sg-empty]').hidden = items.length > 0;
    items.forEach(item => {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = item.url;
      link.className = 'sg-favorites-product';
      if (item.image) {
        try {
          const src = new URL(item.image, location.origin);
          if (src.protocol === 'https:' && (src.origin === location.origin || src.hostname === 'cdn.shopify.com')) {
            const img = document.createElement('img');
            img.src = src.href; img.alt = ''; img.width = 200; img.height = 250; img.loading = 'lazy';
            link.append(img);
          }
        } catch {}
      }
      const title = document.createElement('span');
      title.className = 'sg-favorites-product-title'; title.textContent = item.title;
      const cta = document.createElement('span');
      cta.className = 'sg-favorites-cta'; cta.textContent = labels.view;
      link.append(title, cta);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'sg-favorites-remove'; remove.textContent = labels.remove;
      remove.setAttribute('aria-label', `${labels.remove} — ${item.title}`);
      remove.addEventListener('click', () => {
        const index = items.findIndex(p => p.handle === item.handle);
        if (save(items.filter(p => p.handle !== item.handle), labels.removed)) {
          const buttons = list.querySelectorAll('.sg-favorites-remove');
          (buttons[Math.min(index, buttons.length - 1)] || panel.querySelector('[data-sg-close]')).focus();
        }
      });
      li.append(link, remove); list.append(li);
    });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-sg-open]');
    if (trigger) {
      read(); refresh(); render(); opener = trigger;
      previousOverflow = document.body.style.overflow;
      panel.showModal(); document.body.style.overflow = 'hidden';
      panel.querySelector('[data-sg-close]').focus();
    }
    if (event.target.closest('[data-sg-close]')) panel.close();
  });
  panel.addEventListener('click', event => {
    if (event.target !== panel) return;
    const rect = panel.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
  });
  panel.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; opener?.focus(); });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); refresh(); if (panel.open) render(); } });
  document.addEventListener('shopify:section:load', refresh);
  read();
  customElements.define('sg-favorite', Favorite);
  refresh();
})();
